import { IForm } from 'core-components/classes/models/IForm'

import { IContact } from '../../model/types'

const toAnswer = (value: unknown): IContact['emailPixels'] =>
  value === 'Y' || value === 'N' ? value : null

const listsEmailPixels = (modifiedValues?: string): boolean =>
  modifiedValues?.split(',').some((name) => name.trim().toLowerCase() === 'emailpixels') ?? false

export const mapEmailPixelsAnswer = (data: IForm): IContact['emailPixels'] =>
  toAnswer(
    'EmailPixelsExt' in data && listsEmailPixels(data.ModifiedValues)
      ? data.EmailPixelsExt
      : data.EmailPixels
  )
